<script>
import lazyLoadComponent from '@router/lazyload-component'
const initData = () => {
  return {
    phoneCode: '+886',
    phone: '',
    state: 2,
    hidden: 0,
    name: '',
    alias: '',
    type: '',
    description: '',
    notice: '',
    location: {
      name: '',
      country: '臺灣',
      city: '',
      address: '',
      district: '',
    },
    staffs: [],
    introimage: '',
    image: '',
    images: [],
    video: '',
    orderExtrafields: [],
    allowOverlap: 0,
    showPrice: 1,
    lineId: '',
    lineFriendUrl: '',
    fbFanpageUrl: '',
    lat: '',
    lng: '',
    storeType: ''
  }
}
export default {
  components: {
    BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
    ImageUpload: () => lazyLoadComponent(import('@views/chat/components/FileUpload')),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
  },
  watch: {
  },
  computed: {

  },
  methods: {
    initEditValue() {
      if (this.defaultValue.images.length > 0) {
        for (let i = 0, len = this.defaultValue.images.length; i < len; i++) {
          this.submitData.images.push(this.defaultValue.images[i])
        }
        this.$set(this.submitData, 'images', this.submitData.images)
      }
    }
  },
  mounted() {
    this.showForm = false
    this.initEditValue()
    this.showForm = true
  },
  data() {
    return {
      submitData: {
        images: []
      },
      showForm: false
    }
  }
}
</script>
<template>
  <el-form ref="form" :model="submitData" label-position="top" class="el-form--floating" :class="$style.page">
    <!-- 上方社群資料 -->
    <div :class="$style.socialPart">
      <h4 class="form-block-title">圖片設定</h4>
    </div>
    <el-row :gutter="20">
      <template>
        <el-col :sm="24" :span="24">
          <el-form-item>
            <el-alert title="第一張圖片將會是分店首圖，建議尺寸：首圖
1920*1080px，其他 940*530px" type="warning" show-icon style="padding: 0 16px; margin-top: 5px"> </el-alert>
            <ImageUpload v-if="showForm" v-model="submitData.images" :class="$style.upload" :show-upload="true"
              :resource="'product'" :propsMoreHW="true" :immediate-delete="false">
            </ImageUpload>
          </el-form-item>
        </el-col>
      </template>
      <!-- <template>
        <el-col :sm="12" :span="24">
          <BaseUpload v-model="submitData.logo" imageSize="16:9" suggest-size="480/270" resource="merchant" />
        </el-col>
      </template> -->
    </el-row>
  </el-form>
</template>

<style lang="scss" module>
.page {
  background-color: white;
  padding: 2.227px 20px 18px;
}

.socialPart {
  display: flex;
  align-items: center;

  >h4 {
    margin-right: 12px;
  }
}

.rowHeight {
  height: 96px;
  margin-bottom: 0px;
}
</style>